import "./OurSolution.scss";
import Accordion from "react-bootstrap/Accordion";
import { Fragment, useState } from "react";
import { baseUrl } from "../../../utils/apiData";

const OurSolution = ({ dataList }) => {
  const imageList = dataList?.map((ele) => ele?.image);

  const [num, setNum] = useState(0);

  return (
    <section className="our_solution">
      <div className="content_wrap p_top p_bottom">
        <div className="tab_side">
          <h2 className="wow fadeInUp">Our Offerings</h2>
          {dataList?.length > 0 ? (
            <Accordion defaultActiveKey="0">
              {dataList?.map((data, index) => {
                return (
                  <Fragment key={data._id}>
                    <Accordion.Item
                      eventKey={`${index}`}
                      className={`${num == index ? "active" : ""} wow fadeInUp`}
                      onClick={() => setNum(index)}
                      data-wow-delay={`${index * 0.1}s`}
                    >
                      <Accordion.Header>
                        <p>{data?.name}</p>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="img_wraper">
                          <img
                            src={`${baseUrl}/${data?.image}`}
                            alt="Offering"
                          />
                        </div>
                        <div
                          dangerouslySetInnerHTML={{ __html: data?.content }}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Fragment>
                );
              })}
            </Accordion>
          ) : (
            <p className="text-center mt-5">Data not found...</p>
          )}
        </div>
        <div className="img_wrap">
          <img
            src={`${baseUrl}/${imageList[num]}`}
            alt="Offering"
            className="wow zoomIn"
          />
        </div>
      </div>
    </section>
  );
};

export default OurSolution;
